import styled from 'styled-components';

export const ScTimer = styled.span`
  display: inline-flex;
  gap: 2px;
`;
